module.exports = __webpack_public_path__ + "img/logo.6b242469.svg";